export default "__VITE_ASSET__mKp0UDrt__"